import React, { useEffect, useState } from 'react';
import Avatar from 'react-avatar';
import PropTypes from 'prop-types';
import LocalPrintshopIcon from '@material-ui/icons/LocalPrintshop';
import { withTranslation } from 'react-i18next';
import { ContactProps } from '../../../shared/prop-types/ChatProps';
import { CHAT_CONTACT_TYPES } from '../../../shared/utils/constants';
import DateSelection from '../../../shared/components/form/DateSelection';

const ChatTopbar = ({ contact, t, parameters }) => {
  const [shouldResetReportRage, setShouldResetReportRage] = useState(true);
  const color =
    contact.type === CHAT_CONTACT_TYPES.COMMUNICATION_CHANNEL
      ? '#9099FC'
      : '#1CCA42';

  useEffect(() => {
    setShouldResetReportRage(true);
    setTimeout(() => {
      setShouldResetReportRage(false);
    }, 1000);
  }, [contact]);

  return (
    <div className="chat__topbar">
      <div className="chat__topbar_avatar_contact">
        <Avatar
          size="50"
          round="25px"
          src={contact.urlProfilePhoto}
          name={contact.name}
          color={color}
        />
        {contact && (
          <div className="chat__topbar-contact">
            <p className="chat__topbar-contact-name">{contact.name}</p>
            <p className="chat__topbar-contact-post">
              {t(`chat.subtitle.${contact.type}`)}
            </p>
          </div>
        )}
      </div>
      <DateSelection
        months={2}
        icon={<LocalPrintshopIcon />}
        maxDate={new Date()}
        rangeSelection
        changeHandler={(startDate, finalDate) => {
          parameters(startDate, finalDate);
        }}
        translate={{
          instruction: 'print-chat.instruction',
          button: 'general.generate',
        }}
        shouldReset={shouldResetReportRage}
        maxPeriodInDays={60}
      />
    </div>
  );
};
ChatTopbar.propTypes = {
  contact: ContactProps,
  t: PropTypes.func.isRequired,
  parameters: PropTypes.func.isRequired,
};

ChatTopbar.defaultProps = {
  contact: null,
};

export default withTranslation('common')(ChatTopbar);
